// extracted by mini-css-extract-plugin
module.exports = {"container":"DanjiInfoIcon_container__P0DrY","containerDesktop":"DanjiInfoIcon_containerDesktop__8gkYg"};